import { Box } from '@mui/material';
import { alturaContainer } from 'utils/constants';

const PageContainer = ({ children, marginBottom }: any) => {
  return (
    <Box
      mx="auto"
      mt="50px"
      mb={marginBottom ? '280px' : ''}
      sx={{ backgroundColor: '#f7f7f7', overflowY: 'auto' }}
      height="100%"
      minHeight={alturaContainer}
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      className="pageContainer"
    >
      {children}
    </Box>
  );
};

export default PageContainer;
